import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody, Nav, CardHeader } from "react-bootstrap";

const SALE_TABS = [
  { label: "1개월", suffix: "M1" },
  { label: "3개월", suffix: "M3" },
  { label: "6개월", suffix: "M6" },
  { label: "1년", suffix: "M12" },
];

const buildSaleItems = (items, seltype) => {
  return items
    .filter((item) => item?.seltype === seltype)
    .slice()
    .sort((a, b) => (a?.rank ?? 999) - (b?.rank ?? 999))
    .slice(0, 4);
};

export default function HomeSaleSection({ data }) {
  const curationItems = Array.isArray(data) ? data : [];
  const [fundSeltype, setFundSelType] = useState("fundSaleM1");
  const [guruSeltype, setGuruSelType] = useState("guruSaleM1");

  const guruItems = buildSaleItems(curationItems, guruSeltype);
  const fundItems = buildSaleItems(curationItems, fundSeltype);
  const navigate = useNavigate();

  const handleSaleItemClick = (curtype, seltype, ticker) => {
    if (!ticker) {
      return;
    }

    const query = new URLSearchParams({
      seltype,
      ticker,
    });
    navigate(`/curation/${curtype}?${query.toString()}`);
  };

  const renderSaleList = (items, curtype, seltype) => {
    if (items.length === 0) {
      return <div className="text-secondary fs-sm">표시할 바겐 세일 종목이 없습니다.</div>;
    }

    const getProfitText = (item) => {
      const normalized = item?.info?.replace(/'/g, "\"");
      if (!normalized) return "";
      try {
        const parsed = JSON.parse(normalized);
        return (Math.round(parsed?.profit * 100) / 100).toFixed(2) + " %";
        
      } catch (e) {
        return "";
      }
    }

    return (
      <div>
        {items.map((item, index) => {
          return (
            <Card
              key={`${item?.seltype}-${index}`}
              className="mb-2"
              style={{ height: "130px", cursor: item?.ticker ? "pointer" : "default" }}
              role="button"
              tabIndex={item?.ticker ? 0 : undefined}
              onClick={() => handleSaleItemClick(curtype, seltype, item?.ticker)}
            >
              <CardHeader className="home-sale-card-header">
                <div className="home-sale-item-head d-flex justify-content-between">
                  <div className="home-sale-item-title-desktop">
                    {item.nickname}, {item?.companyKor} ({item?.ticker})
                  </div>
                  <div className="home-sale-item-title-mobile">
                    <div className="home-sale-item-title-main">
                      {item?.companyKor} ({item?.ticker})
                    </div>
                    <div className="home-sale-item-title-sub text-secondary">
                      {item?.nickname}
                    </div>
                  </div>
                  <div className="home-sale-item-profit d-flex align-items-center gap-2">
                    <div className="text-secondary fs-xs home-sale-item-profit-label">
                      Sale
                    </div>
                    <div className="text-danger fw-bold home-sale-item-profit-value">
                      {getProfitText(item)}
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="overflow-auto">
                <div style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }} className="text-secondary">
                  {item.intro}
                </div>
              </CardBody>
            </Card>
          );
        })}
      </div>

    );
  };

  return (
    <Row>
      <Col sm="12" md="6" lg="6" className="mb-3">
        <Card>
          <CardBody>
            <div className="home-section-header">
              <div>
                <div className="home-section-title">투자대가 바겐세일종목</div>
                <div className="home-section-subtitle">위대한 투자자들보다 싸게 살 기회예요!</div>
              </div>
              <button type="button" className="home-section-link" onClick={() => {navigate("/curation/guruSale")}}>
                더보기
              </button>
            </div>
            <Nav className="nav-line mb-3">
              {SALE_TABS.map((tab) => {
                const nextSeltype = `guruSale${tab.suffix}`;
                const isActive = guruSeltype === nextSeltype;

                return (
                  <Nav.Link
                    key={nextSeltype}
                    as="button"
                    type="button"
                    className={isActive ? "active" : ""}
                    active={isActive}
                    onClick={() => setGuruSelType(nextSeltype)}
                  >
                    {tab.label}
                  </Nav.Link>
                );
              })}
            </Nav>
            {renderSaleList(guruItems, "guruSale", guruSeltype)}
          </CardBody>
        </Card>
      </Col>
      <Col sm="12" md="6" lg="6">
        <Card>
          <CardBody>
            <div className="home-section-header">
              <div>
                <div className="home-section-title">연기금 바겐세일 종목</div>
                <div className="home-section-subtitle">신중한 연기금들이 선택한 종목임에도 바겐세일 중!</div>
              </div>
              <button type="button" className="home-section-link" onClick={() => {navigate("/curation/fundSale")}}>
                더보기
              </button>
            </div>
            <Nav className="nav-line mb-3">
              {SALE_TABS.map((tab) => {
                const nextSeltype = `fundSale${tab.suffix}`;
                const isActive = fundSeltype === nextSeltype;

                return (
                  <Nav.Link
                    key={nextSeltype}
                    as="button"
                    type="button"
                    className={isActive ? "active" : ""}
                    active={isActive}
                    onClick={() => setFundSelType(nextSeltype)}
                  >
                    {tab.label}
                  </Nav.Link>
                );
              })}
            </Nav>
            {renderSaleList(fundItems, "fundSale", fundSeltype)}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
